module.exports = "//static.hsappstatic.net/ContentComponents/static-2.71718/img/DeepL-logo.png"